(function ($, undefined) {


	var getLoading = function ($el) {

		var $loading = $el.data('$loading');

		if (!$loading) {
			$loading = $('<div />', { 'class': 'loadingOverlay' });
			$el.data('$loading', $loading);

			var zIndex = $el.css('z-index');
			if (zIndex == 'auto') {
				zIndex = '9999';
			}
			if (zIndex) {
				$loading.css('z-index', zIndex);
			}

			var $parent = $el.hasClass('module') ? $el : $el.offsetParent();
			$parent.append($loading);

			// destroy/cleanup
			$el.on('remove', function () {
				$loading.remove();
			});
		}

		return $loading;

	}

	$.fn.showLoading = function () {

		return this.each(function () {

			var $el = $(this);

			var $loading = getLoading($el);
			var position = $el.hasClass('module') ? { top: 0, left: 0 } : $el.position();

			var position = {
				width: $el.outerWidth(true),
				height: $el.outerHeight(true),
				top: position.top,
				left: position.left
			};

			$loading.stop().css(position).show();
		});

	}


	$.fn.hideLoading = function () {

		return this.each(function () {

			var $el = $(this);

			var $loading = getLoading($el);

			$loading.stop().fadeOut();

		});

	}



}(jQuery));